// extracted by mini-css-extract-plugin
module.exports = {"textarea__error":"SGSTextarea_textarea__error__3yUgB","label":"SGSTextarea_label__1sczp","label__error":"SGSTextarea_label__error__3AVjh"};